import React from 'react'
import ColorsContainer from "app/react/components/colors/ColorsContainer";
import ColorsContent from "app/react/components/colors/ColorsContent";

export default function ColorsOverview (props) {
  return (
    <ColorsContainer {...props}>
      <ColorsContent/>
    </ColorsContainer>
  )
}